import { useMemo } from 'react';
import { useEditor } from '../../hooks/useEditor.js';
import { List } from './TreeList.style.js';
import { TreeListItem } from './TreeListItem.js';
import { jsx } from '@emotion/react';

function TreeList() {
  var _useEditor = useEditor(),
    document = _useEditor.state.document;
  var path = useMemo(function () {
    return [];
  }, []);
  return jsx(List, null, jsx(TreeListItem, {
    node: document,
    path: path
  }));
}

export { TreeList };
//# sourceMappingURL=TreeList.js.map
